import { render, staticRenderFns } from "./ShortReportPreviewModal.vue?vue&type=template&id=60053004&scoped=true"
import script from "./ShortReportPreviewModal.vue?vue&type=script&lang=js"
export * from "./ShortReportPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./ShortReportPreviewModal.vue?vue&type=style&index=0&id=60053004&prod&lang=scss"
import style1 from "./ShortReportPreviewModal.vue?vue&type=style&index=1&id=60053004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60053004",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon})
